module.exports = __webpack_public_path__ + "static/media/amazon-com-light.cf884b51.svg";